var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.40413,
    y: 2.40413,
    width: 78.1917,
    height: 78.1917,
    rx: 39.0959,
    stroke: "white",
    strokeWidth: 4.80827
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 39.2524C25.4826 39.2524 24.2524 40.4826 24.2524 42C24.2524 43.5174 25.4826 44.7476 27 44.7476V39.2524ZM57.9428 43.9428C59.0158 42.8698 59.0158 41.1302 57.9428 40.0572L40.4573 22.5717C39.3843 21.4987 37.6447 21.4987 36.5717 22.5717C35.4987 23.6447 35.4987 25.3843 36.5717 26.4573L52.1143 42L36.5717 57.5427C35.4987 58.6157 35.4987 60.3553 36.5717 61.4283C37.6447 62.5013 39.3843 62.5013 40.4573 61.4283L57.9428 43.9428ZM27 44.7476H56V39.2524H27V44.7476Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.9fc8f981df53a0f6248945c5e62df318.svg";
export { ForwardRef as ReactComponent };